export const baseUrl = "/authentication/sso";
